module.exports = __webpack_public_path__ + "static/media/alexir_media.282d3b64.gif";